/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shoot_Share_Connect_Uses_StripInputs */

const en_shoot_share_connect_uses_strip = /** @type {(inputs: Shoot_Share_Connect_Uses_StripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect uses Stripe Express to route payments directly to your bank account. You own the transaction, you own the customer data, and you get paid instantly.`)
};

const es_shoot_share_connect_uses_strip = /** @type {(inputs: Shoot_Share_Connect_Uses_StripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect usa Stripe Express para enviar los pagos directamente a tu cuenta bancaria. Eres dueño de la transacción, de los datos del cliente y recibes tu dinero al instante.`)
};

const fr_shoot_share_connect_uses_strip = /** @type {(inputs: Shoot_Share_Connect_Uses_StripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect utilise Stripe Express pour acheminer les paiements directement vers votre compte bancaire. Vous possédez la transaction, vous possédez les données client, et vous êtes payé instantanément.`)
};

const de_shoot_share_connect_uses_strip = /** @type {(inputs: Shoot_Share_Connect_Uses_StripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect nutzt Stripe Express, um Zahlungen direkt auf dein Bankkonto weiterzuleiten. Die Transaktion und die Kundendaten gehören dir und du wirst sofort bezahlt.`)
};

const ja_shoot_share_connect_uses_strip = /** @type {(inputs: Shoot_Share_Connect_Uses_StripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share ConnectはStripe Expressを使用して、銀行口座に直接支払いをルーティングします。取引を所有し、顧客データを所有し、即座に支払いを受け取ることができます。`)
};

const zh_shoot_share_connect_uses_strip = /** @type {(inputs: Shoot_Share_Connect_Uses_StripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect 使用 Stripe Express 将付款直接路由到您的银行账户。您拥有交易本身、拥有客户数据，并能即时获得付款。`)
};

const ar_shoot_share_connect_uses_strip = /** @type {(inputs: Shoot_Share_Connect_Uses_StripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تستخدم Shoot Share Connect خدمة Stripe Express لتوجيه المدفوعات مباشرة إلى حسابك المصرفي. أنت تملك المعاملة، وتملك بيانات العميل، وتتلقى أموالك على الفور.`)
};

const id_shoot_share_connect_uses_strip = /** @type {(inputs: Shoot_Share_Connect_Uses_StripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect menggunakan Stripe Express untuk mengarahkan pembayaran langsung ke rekening bank Anda. Anda memiliki transaksinya, Anda memiliki data pelanggan, dan Anda dibayar secara instan.`)
};

const it_shoot_share_connect_uses_strip = /** @type {(inputs: Shoot_Share_Connect_Uses_StripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect utilizza Stripe Express per instradare i pagamenti direttamente sul tuo conto bancario. Tu possiedi la transazione, tu possiedi i dati del cliente e vieni pagato all'istante.`)
};

const ru_shoot_share_connect_uses_strip = /** @type {(inputs: Shoot_Share_Connect_Uses_StripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect использует Stripe Express для перевода платежей напрямую на ваш банковский счет. Вы владеете транзакцией, данными клиентов и получаете оплату мгновенно.`)
};

const pt_shoot_share_connect_uses_strip = /** @type {(inputs: Shoot_Share_Connect_Uses_StripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Shoot Share Connect usa o Stripe Express para encaminhar pagamentos diretamente para a sua conta bancária. Você é dono da transação, dos dados do cliente e recebe o pagamento instantaneamente.`)
};

const ko_shoot_share_connect_uses_strip = /** @type {(inputs: Shoot_Share_Connect_Uses_StripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect는 Stripe Express를 사용하여 결제 대금을 귀하의 은행 계좌로 직접 라우팅합니다. 귀하가 거래를 소유하고, 고객 데이터를 소유하며, 대금을 즉시 지급받습니다.`)
};

/**
* | output |
* | --- |
* | "Shoot Share Connect uses Stripe Express to route payments directly to your bank account. You own the transaction, you own the customer data, and you get paid..." |
*
* @param {Shoot_Share_Connect_Uses_StripInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const shoot_share_connect_uses_strip = /** @type {((inputs?: Shoot_Share_Connect_Uses_StripInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shoot_Share_Connect_Uses_StripInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shoot_share_connect_uses_strip(inputs)
	if (locale === "es") return es_shoot_share_connect_uses_strip(inputs)
	if (locale === "fr") return fr_shoot_share_connect_uses_strip(inputs)
	if (locale === "de") return de_shoot_share_connect_uses_strip(inputs)
	if (locale === "ja") return ja_shoot_share_connect_uses_strip(inputs)
	if (locale === "zh") return zh_shoot_share_connect_uses_strip(inputs)
	if (locale === "ar") return ar_shoot_share_connect_uses_strip(inputs)
	if (locale === "id") return id_shoot_share_connect_uses_strip(inputs)
	if (locale === "it") return it_shoot_share_connect_uses_strip(inputs)
	if (locale === "ru") return ru_shoot_share_connect_uses_strip(inputs)
	if (locale === "pt") return pt_shoot_share_connect_uses_strip(inputs)
	return ko_shoot_share_connect_uses_strip(inputs)
});